var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9156 9.04661C19.9156 11.303 18.0784 13.14 15.822 13.14H7.83485C6.23731 13.14 4.93958 14.438 4.93958 16.0354C4.93958 17.6228 6.23731 18.9308 7.83485 18.9308H12.3276C12.6572 18.9308 12.9268 19.1904 12.9268 19.5298C12.9268 19.8592 12.6572 20.1288 12.3276 20.1288H7.83485C5.57846 20.1288 3.74131 18.2918 3.74131 16.0354C3.74131 13.769 5.57845 11.942 7.83485 11.942H15.822C17.4196 11.942 18.7173 10.634 18.7173 9.04661C18.7173 7.44919 17.4196 6.15123 15.822 6.15123H9.42239C9.1428 7.59886 7.86482 8.69719 6.33725 8.69719C4.60004 8.69719 3.19238 7.27942 3.19238 5.55221C3.19238 3.815 4.60004 2.40723 6.33725 2.40723C7.87482 2.40723 9.14281 3.50544 9.43238 4.95319H15.822C18.0784 4.9532 19.9156 6.78023 19.9156 9.04661Z",
    fill: "#1B192F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7365 15.1081C21.5025 14.8741 21.1242 14.8741 20.8902 15.1081L16.3214 19.6765L13.7493 17.1049C13.5153 16.8709 13.137 16.8709 12.903 17.1049C12.669 17.3389 12.669 17.7182 12.903 17.9522L15.8982 20.9474C16.0152 21.0644 16.1683 21.1229 16.3214 21.1229C16.4745 21.1229 16.6275 21.0644 16.7445 20.9474L21.7365 15.9554C21.9705 15.7214 21.9705 15.3421 21.7365 15.1081Z",
    fill: "#1B192F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5626187235a159b8dff7be9a428089aa.svg";
export { ForwardRef as ReactComponent };